import type { TypePolicies } from '../../../utils';

export const typePolicies: TypePolicies = {
  /**
   * normalization is disabled as `CollectionAsset` is essentially just an ordinal that points to an Asset in a particular
   * ordered and/or grouped list. this fixes @see FIND-1068
   */
  CollectionAsset: {
    keyFields: false,
  },
};
